<qaroni-status-preview
  [status]="status() | absenceEmployeeStatus"
  [bgColorClass]="bgColorClass" />
